import { Injectable } from '@angular/core';
import {ScrollTrigger} from "gsap/ScrollTrigger";
@Injectable({
  providedIn: 'root'
})
export class ScrollTriggerService {

  private _currentScrollTriggers: ScrollTrigger[] = [];

  constructor() { }

  addST(st: ScrollTrigger) {
    this._currentScrollTriggers.push(st);
  }

  removeST(st: ScrollTrigger) {
    this._currentScrollTriggers = this._currentScrollTriggers.filter((el) => el !== st);
  }

  updateTriggers() {
    this._currentScrollTriggers.forEach((st) => { st.refresh(); });
  }

}
